import { useAuth } from '../composables/useAuth'
import { useTenant } from '../stores/useTenant'

const authRoutes: (string | RegExp)[] = ['/login']

const isAuthRoute = (route: string) =>
  authRoutes.some((x) =>
    typeof x === 'string' ? route === x : (x?.test(route) ?? false),
  )

const isPrivateRoute = (route: string) => route.startsWith('/app')

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const auth = useAuth()
  const config = useRuntimeConfig()

  const isPublicEnabled = config.public.enablePublicPages

  // Allow 404 page to show
  if (!to.matched.length) return

  // Redirect public routes if they are disabled (v1 simplification)
  const isSystemRoute =
    to.path.startsWith('/app') ||
    to.path === '/login' ||
    to.path === '/new-tenant'

  if (!isPublicEnabled && !isSystemRoute) {
    return navigateTo('/app')
  }

  if (!auth.user && isPrivateRoute(to.path)) {
    await auth.reAuthenticate()
    const user = auth.user as any
    if (user) {
      if (!user.tenantId && to.path !== '/new-tenant') {
        return navigateTo('/new-tenant')
      }
      return
    }
    return navigateTo('/login')
  }

  const user = auth.user as any
  if (
    user &&
    !user.tenantId &&
    to.path !== '/new-tenant' &&
    isPrivateRoute(to.path)
  ) {
    return navigateTo('/new-tenant')
  }

  if (auth.user && isAuthRoute(to.path)) {
    if (authRoutes.includes(to.path)) return navigateTo('/app')
  }
})
